import React, { useState, useeffect, useRef } from "react";
import $ from "jquery";
import { useNavigate, useLocation } from "react-router-dom";
import appIcon from "../assets/images/appIcon_round.webp";

import Axios from "axios";
import view from "../assets/images/view.png";
import hide from "../assets/images/hide.png";
import { message } from "antd";
export default () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const [name, setName] = useState("");
  // const [gender, setGender] = useState("");
  const [userID, setuserID] = useState("");
  const [password, setPassword] = useState("");
  console.log("userID::", userID, password);

  const [confirmPassword, setconfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [msg, setMsg] = useState("");
  const [buttonHide, setButtonHide] = useState(false);
  const [otpValue, setOtpValue] = useState(false);
  console.log("otpValue::::", otpValue);

  const [sendingOTP, setSendingOTP] = useState(false);
  const [yourOTP, setYourOTP] = useState("");
  const [OTPbackendResponse, setOTPBackendResponse] = useState("");
  const [waitingMsg, setWaitingMsg] = useState("");
  const [isDisplayOTP, setIsDisplayOTP] = useState(false);
  const [OTPsectionHide, setOTPSectionHide] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [phoneChecked, setPhoneChecked] = useState(true); // Phone checkbox ticked by default
  const [emailChecked, setEmailChecked] = useState(false); // Email checkbox not ticked by default


  const onNameUpdate = (e) => {
    setName(e.target.value);
  };
  // const onGenderUpdate = (e) => {
  //   setGender(e.target.value);
  // };
  const onEmailUpdate = (e) => {
    setEmail(e.target.value);
  };
  const onPhoneUpdate = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setPhone(value);
      setuserID(value);
    }
  };

  const validateEmail = (email) => {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  };

  const validatePassword = (password) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/.test(password);
  };
  
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);

  const onComplete = (otp) => {
    console.log("OTP entered:", otp);
    // You can add any additional logic here if needed
  };

  const handleChange = (index, value) => {
    if (isNaN(value)) return; // Allow only numbers

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }

    // Trigger onComplete if all fields are filled
    if (newOtp.every((digit) => digit !== "")) {
      onComplete(newOtp.join(""));
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      // If the current input is empty, move focus to the previous input and clear its value
      if (!otp[index] && index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = ""; // Clear the previous input
        setOtp(newOtp);
        inputRefs.current[index - 1].focus();
      }
    }

    // Allow navigation with arrow keys
    if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
    if (e.key === "ArrowRight" && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain").trim();
    if (pasteData.length === 6 && !isNaN(pasteData)) {
      const newOtp = pasteData.split("").slice(0, 6);
      setOtp(newOtp);
      onComplete(newOtp.join(""));
    }
  };


  const continueHandler = (e) => {
    setErrMsg("");
    setMsg("");
    setWaitingMsg("");
    const newOtp = otp.join("");
    if (OTPbackendResponse == newOtp) {
      setButtonHide(true);
      setWaitingMsg("Please Wait");
      e.preventDefault();
      let formdata = $(e.target);
      formdata = new FormData();
      formdata.append("first_name", name);
      formdata.append("email", email);
      formdata.append("phone_number", phone);
      formdata.append("user_id", userID);
      formdata.append("password", password);
      // formdata.append("gender", gender);
      formdata.append('MDT', 'PM');
      $.ajax({
        type: "POST",
        url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/Patients/sign_up`,
        data: formdata,
        processData: false,
        contentType: false,
        success(data) {
          console.log(data);

          if (data.status == "1") {
            setYourOTP("");
            // setOtpValue(true)
            setWaitingMsg("");
            console.log(
              "continueHandler:patient register success response:  ",
              data
            );
            setButtonHide(false);
            // localStorage.setItem("phoneNo", phone);
            navigate("/");
          }
          if (data.status == "0") {
            // setOtpValue(true)
            setYourOTP("");
            setWaitingMsg("");
            setErrMsg(
              "Your phone no already registered in this app please login"
            );
          }
        },
        error: function (err) {
          setWaitingMsg("");
          console.log("SignupError::::", err?.responseJSON?.message);
          setErrMsg(err?.responseJSON?.message);
        },
      });
    } else {
      e.preventDefault();
      setMsg("OTP is not matching");
    }
  };
  // for otp
  const sendOTPHandler = (e) => {
    e.preventDefault();
    setErrMsg("");
    setMsg("");
    setWaitingMsg("");

    if (!name || !phone || !password || !userID) {
      setErrMsg("Please fill all mandatory fields.");
      return;
    }

    if (phone.length !== 10) {
      setErrMsg("Phone number must be exactly 10 digits.");
      return;
    }

    if (!phoneChecked && !emailChecked) {
      setErrMsg("Please select at least one option (phone or Email).");
      return;
    }

    if (emailChecked && !email) {
      setErrMsg("Receive otp via email is selected, but the email field is empty. Please enter your email.");
      return;
    }

    if (emailChecked && !validateEmail(email)) {
      setErrMsg("Invalid email format.");
      return;
    }

    if (!validatePassword(password)) {
      setErrMsg("Password must be at least 6 characters, contain one uppercase, one lowercase, and one number.");
      return;
    }

    setSendingOTP(true);
    setButtonHide(true);
    setOtpValue(true);
    setMsg("");

    Axios.get(
      `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/Misc/sendotp?phone=${phone}&MDT=PM&email=${email}&email_check=${emailChecked}&phone_check=${phoneChecked}`
    )
      .then((OTPresponse) => {
        setYourOTP(OTPresponse.data);
        setSendingOTP(false);
        setButtonHide(false);
        message.success("OTP sent successfully! Please check your phone to proceed.");
        if (OTPresponse.data.OTP_SMS_RESPONSE === "No") {
          setOTPBackendResponse(OTPresponse.data.OTP);
          setOTPSectionHide(true);
          setIsDisplayOTP(true);
        } else {
          setOTPBackendResponse(OTPresponse.data.OTP);
          setOTPSectionHide(true);
          setIsDisplayOTP(false);
        }
      })
      .catch((err) => {
        console.log("Reset Password: otp send failed", err);
        message.error("Failed to send OTP. Please try again later.");
        setSendingOTP(false);
        setButtonHide(false);
      });
  };

  const resendOTP = (e) => {
    setErrMsg("");
    setMsg("");
    setWaitingMsg("");
    Axios.get(
      `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/Misc/sendotp?phone=${phone}&MDT=PM`
    )
      .then((OTPresponse) => {
        setYourOTP(OTPresponse.data);
        console.log("sendOTPHandler:otp response \n", OTPresponse.data);
        setSendingOTP(false);
        setButtonHide(false);
        message.success("OTP resend successfully! Please check your phone.");
        if (OTPresponse.data.OTP_SMS_RESPONSE == "No") {
          setOTPBackendResponse(OTPresponse.data.OTP);
          setOTPSectionHide(true);
          setIsDisplayOTP(true);
          //setOtpValue(true);
        } else {
          setOTPBackendResponse(OTPresponse.data.OTP);
          setOTPSectionHide(true);
          //setOtpValue(true);
          setIsDisplayOTP(false);
        }
      })
      .catch((err) => {
        console.log("otp send failed", err);
        message.error("Failed to resend OTP. Please try again later.");
        setSendingOTP(false);
        //setOtpValue(true);
        setButtonHide(false);
      });
  };

  return (
    <div className="background-container" >
      <div
        style={{
          width: "100%",
          height: "100%",
          // backgroundColor: "#f8f9fa", // Light color
          borderRadius: "15px", // Rounded corners
          boxShadow:
            "0px 4px 6px rgba(0, 0, 0, 0.5), 0px 1px 3px rgba(0, 0, 0, 0.06)", // 3D shadow effect

          justifyContent: "center",
          alignItems: "center",
          position: "absolute",

          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // Centers the box
        }}
      >
        <div>
          <img
            src={appIcon}
            style={{ height: 130, width: 130, marginTop: 5 }}
          />
        </div>
        <div>
          <h3
            style={{
              textAlign: "center",
              marginTop: 40,
              fontWeight: "bold",
              fontSize: 24,
            }}
          >
            Sign Up
          </h3>
        </div>

        <div style={{ textAlign: "center", marginTop: 15, }}>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", marginTop: 15 }}>
            <div style={{ textAlign: "center", width: '80%' }}>
              <div style={{ textAlign: "left" }}>
                <a style={{ textDecoration: "none", fontSize: 15, fontWeight: "600" }}>Name *</a>
              </div>
              <input
                onChange={onNameUpdate}
                style={{
                  border: "1px solid rgb(185, 184, 184)",
                  backgroundColor: "#DDDDDD",
                  color: "black",
                  width: "100%",
                  height: 40,
                  fontSize: 16,
                  borderRadius: 8,
                  textAlign: "center",
                }}
                type="text"
                placeholder="Enter your name"
              />
            </div>
            <div style={{ textAlign: "center", width: '80%' }}>
              <div style={{ textAlign: "left" }}>
                <label style={{ textDecoration: "none", fontSize: 15, fontWeight: "600" }}>Phone *</label>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <input
                  onChange={onPhoneUpdate}
                  value={phone}
                  style={{
                    border: "1px solid rgb(185, 184, 184)",
                    backgroundColor: "#DDDDDD",
                    color: "black",
                    width: "100%",
                    height: 40,
                    fontSize: 16,
                    borderRadius: 8,
                    textAlign: "center",
                  }}
                  type="tel"
                  placeholder="Enter your phone number"
                  maxLength={10}
                />
              </div>
            </div>
            <div style={{ textAlign: "center", width: '80%' }}>
              <div style={{ textAlign: "left" }}>
                <label style={{ textDecoration: "none", fontSize: 15, fontWeight: "600" }}>Email</label>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <input
                  onChange={onEmailUpdate}
                  style={{
                    border: "1px solid rgb(185, 184, 184)",
                    backgroundColor: "#DDDDDD",
                    color: "black",
                    width: "100%",
                    height: 40,
                    fontSize: 16,
                    borderRadius: 8,
                    textAlign: "center",
                  }}
                  type="tel"
                  placeholder="Enter your email"
                />
              </div>
            </div>
            {/* <div style={{ textAlign: "center", width: '80%' }}>
              <div style={{ textAlign: "left" }}>
                <a style={{ textDecoration: "none", fontSize: 15, fontWeight: "600" }}>Gender *</a>
              </div>
              <select
                onChange={onGenderUpdate}
                style={{
                  border: "1px solid rgb(185, 184, 184)",
                  backgroundColor: "#DDDDDD",
                  color: "black",
                  width: "100%",
                  height: 40,
                  fontSize: 16,
                  borderRadius: 8,
                  textAlign: "center",
                }}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Others">Others</option>
              </select>
            </div> */}
            {/* <div style={{ textAlign: "center", width: '80%' }}>
              <div style={{ textAlign: "left" }}>
                <a style={{ textDecoration: "none", fontSize: 15, fontWeight: "600" }}>User Id *</a>
              </div>
              <input
                onChange={(e) => setuserID(e.target.value)}
                style={{
                  border: "1px solid rgb(185, 184, 184)",
                  backgroundColor: "#DDDDDD",
                  color: "black",
                  width: "100%",
                  height: 40,
                  fontSize: 16,
                  borderRadius: 8,
                  textAlign: "center",
                }}
                type="text"
                placeholder="Enter your User ID"
              />
            </div> */}
            <div style={{ textAlign: "center", width: '80%' }}>
              <div style={{ textAlign: "left" }}>
                <label style={{ textDecoration: "none", fontSize: 15, fontWeight: "600" }}>Password *</label>
              </div>
              <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                <input
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  style={{
                    border: "1px solid rgb(185, 184, 184)",
                    backgroundColor: "#DDDDDD",
                    color: "black",
                    width: "100%",
                    height: 40,
                    paddingRight: 30,
                    fontSize: 16,
                    borderRadius: 8,
                    textAlign: "center",
                  }}
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                />
                <span
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "gray",
                    fontSize: 20,
                  }}
                >
                  {showPassword ? (
                    <img src={view} style={{ height: 16, width: 16, borderRadius: 4 }} />
                  ) : (
                    <img src={hide} style={{ height: 16, width: 16, borderRadius: 4 }} />
                  )}
                </span>
              </div>
            </div>
            <div style={{ textAlign: "center", width: '80%' }}>
              <div style={{ textAlign: "left" }}>
                <label style={{ textDecoration: "none", fontSize: 15, fontWeight: "600" }}>Receive OTP via *</label>
              </div>
              <div style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
                <label>Phone</label>
                <input
                  type="checkbox"
                  checked={phoneChecked}
                  onChange={(e) => setPhoneChecked(e.target.checked)}
                  style={{ height: 20, width: 20, marginLeft: 5 }}
                />
                <label style={{ marginLeft: 10 }}>Email</label>
                <input
                  type="checkbox"
                  checked={emailChecked}
                  onChange={(e) => setEmailChecked(e.target.checked)}
                  style={{ height: 20, width: 20, marginLeft: 5 }}
                />
              </div>
            </div>
          </div>
          {otpValue ? (
            <>
              <p
                style={{
                  textAlign: "left",
                  fontSize: 14,
                  fontWeight: "bold",
                  marginLeft: 25,
                  marginTop: 15,
                }}
              >
                Enter otp
              </p>
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="tel"
                  maxLength="1"
                  value={digit}
                  ref={(el) => (inputRefs.current[index] = el)}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  onFocus={(e) => e.target.select()}
                  style={{
                    width: "40px",
                    height: "50px",
                    margin: "0 5px",
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                  }}
                />
              ))}

              {isDisplayOTP ? (
                <p
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: "#6080eeed",
                    marginTop: 20,
                  }}
                >
                  Your OTP IS : {OTPbackendResponse}
                </p>
              ) : null}
              <p
                style={{ fontSize: 16, color: "#6080eeed" }}
                onClick={resendOTP}
              >
                Resend Otp
              </p>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <form
                  method="post"
                  onSubmit={(event) => continueHandler(event)}
                >
                  <button className="otp_button" type="submit">
                    Continue
                  </button>
                </form>
              </div>
            </>
          ) : (
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <form method="post" onClick={sendOTPHandler}>
                {buttonHide == false ? (
                  <button className="otp_button" style={{ width:"80%" }} type="submit">
                    SEND OTP
                  </button>
                ) : (
                  <p
                    style={{ fontSize: 14, fontWeight: "bold", color: "green" }}
                  >
                    Please wait...
                  </p>
                )}
              </form>
            </div>
          )}
          {errMsg ? (
            <p
              style={{
                marginTop: 10,
                marginLeft: "15px",
                marginRight: "auto",
                color: "red",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              {errMsg}
            </p>
          ) : null}

          {msg ? (
            <p
              style={{
                fontSize: 16,
                fontWeight: "bold",
                color: "red",
                marginTop: 10,
                textAlign: "center",
              }}
            >
              {msg}
            </p>
          ) : null}
          {waitingMsg ? (
            <p
              style={{
                fontSize: 16,
                fontWeight: "bold",
                color: "green",
                marginTop: 10,
                textAlign: "center",
              }}
            >
              {waitingMsg}
            </p>
          ) : null}
        </div>
        <br />

        {/* {otpValue ? (
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
          >
            <form method="post" onSubmit={(event) => continueHandler(event)}>
              {buttonHide == false ? (
                <button className="otp_button otp_button2" type="submit">
                  Continue
                </button>
              ) : null}
            </form>
          </div>
        ) : (
          
        )} */}

        <div style={{ marginTop: 20, marginBottom: 20 }}>
          <p>
            Already have an account?&nbsp;
            <a
              style={{
                textDecoration: "none",
                fontSize: 15,
                fontWeight: "bold",
              }}
              href="/Login"
            >
              Sign In
            </a>{" "}
          </p>
        </div>
      </div>
    </div>
  );
};
